import script from "./AdminArticleList.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminArticleList.vue?vue&type=script&setup=true&lang=js"

import "./AdminArticleList.vue?vue&type=style&index=0&id=ffab255c&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ffab255c"]])

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QPageSticky from 'quasar/src/components/page-sticky/QPageSticky.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QImg,QPageSticky});
